export const LanguageDataZhCht = {
  AssociationValue: "關聯值",
  AssociationField: "關聯字段",
  String: "文本",
  Text: "備註",
  Integer: "整數",
  Decimal: "浮點數字",
  Boolean: "布爾型",
  Date: "日期",
  Time: "時間",
  DateTime: "日期時間",
  Binary: "二進制",
  UnifiedDataType: "業務字段",
  None: "無",
  Association: "關聯",
  Enum: "枚舉",
  DynamicProp: "動態屬性",
  PublicHelp: "公共幫助",
  SystemProcess: "系統處理",
  CreatingTime: "創建時",
  SavingTime: "保存時",
  Geometry: "幾何"
}
